import { ColorModeScript } from "@chakra-ui/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import calculateViewHeight from "./calculateViewHeight";
import { Router } from "./scenes/Router";
import { initSentry } from "./services/sentry";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container!);

if (import.meta.env.PROD) {
  initSentry();
}

// WARNING!!! disabled strict mode by changing the tag to <> when debugging anything
// related to markers or the map.
root.render(
  <>
    <ColorModeScript />
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  </>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { type: "module" });
  });
}

calculateViewHeight();
